export const FENCES_CATALOG_PDF_PATH = '/pdf/mikino-info.pdf';
